import Client from './KomodoClient';
import { PAGE_ALL, pagerRows } from './Resource';

// komodo messi (notifications): MessiController — subscriptions of the current user, push list, read.
export const BIZ_TYPE = {
	NONE: 0,
	NEW_STOCK_IN_OUT: 1,
	NEW_ECOMMERCE_ORDER: 2,
};
export const PUSH_TYPE = { NONE: 0, EMAIL: 1, NOTIFICATION: 2 };

// → MessiSubscribeEditDTO[] { bizType, byNotification, byEmail, onlyMyBuz, sendToPerson }
const subscriptions = () => Client.get('/api/messi');
// ItemListRecord<MessiSubscribeEditDTO>; the server replaces all rows of the user.
const saveSubscriptions = (items) =>
	Client.post('/api/messi', { recordList: items });
// MessiPushQc { deptCode, pushType, bizType, unreadFirst } → PagerRecord<MessiPushDTO>
const pushes = (query) =>
	Client.post('/api/messi/messi-push/query-pager', {
		...PAGE_ALL,
		pageItems: 200,
		...(query || {}),
	}).then(pagerRows);
// MessiReadRequest { pid?, deptCode }: with pid marks the whole business key group, without marks all.
const read = (deptCode, pid) =>
	Client.post('/api/messi/read', { pid: pid || null, deptCode });

export default {
	subscriptions,
	saveSubscriptions,
	pushes,
	read,
	BIZ_TYPE,
	PUSH_TYPE,
};
